var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tags"},_vm._l((_vm.data),function(item,index){return _c('el-tag',{key:index,attrs:{"type":_vm.types[index%_vm.types.length]}},[_vm._v(_vm._s(item))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }